import NandaniAvatar from "../../assets/team/avatar-nandani.png";
import AmanAvatar from "../../assets/team/avatar-aman.png";
import SheetalAvatar from "../../assets/team/avatar-sheetal.jpg";
import PrashantAvatar from "../../assets/team/avatar-prashant.jpg";
import VishwajeetAvatar from "../../assets/team/avatar-vishwajeet.jpg";

const People = [
	{
		name: "Nandani Paliwal",
		role: "Frontend Developer",
		imageUrl: NandaniAvatar,
		twitterUrl: "https://twitter.com/Nandanipaliwal",
		linkedinUrl: "https://www.linkedin.com/in/nandanipaliwal/",
	},
	{
		name: "Sheetal Tyagi",
		role: "Full Stack Developer",
		imageUrl: SheetalAvatar,
		twitterUrl: "https://twitter.com/Sheetal8653",
		linkedinUrl: "https://www.linkedin.com/in/sheetal-tyagi-39b62b21b/",
	},
	{
		name: "Aman kumar Gupta",
		role: "MERN Developer",
		imageUrl: AmanAvatar,
		twitterUrl: "https://twitter.com/AmanGup03229924",
		linkedinUrl: "https://www.linkedin.com/in/aman-gupta-2b6164212/",
	},
	{
		name: "Vishwajeet",
		role: "Backend Developer",
		imageUrl: VishwajeetAvatar,
		twitterUrl: "https://twitter.com/TechVishwajeet",
		linkedinUrl: "https://www.linkedin.com/in/techyvishwajeet/",
	},

	{
		name: "Prashant Dubey",
		role: "Android Developer",
		imageUrl: PrashantAvatar,
		twitterUrl: "https://twitter.com/Prashant______p",
		linkedinUrl: "https://www.linkedin.com/in/prashantdubey2001/",
	},
];
export default People;
